import React, { useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { Box, CircularProgress, Typography } from '@mui/material';

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
const GOOGLE_MAPS_LIBRARIES: ('places' | 'drawing' | 'geometry' | 'localContext' | 'visualization')[] = ['places'];

interface GoogleMapsProviderProps {
  children: React.ReactNode;
}

const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
    region: 'AU', // Bias results to Australia
    language: 'en',
  });

  useEffect(() => {
    console.log('[GoogleMapsProvider] API Key:', GOOGLE_MAPS_API_KEY ? 'Set (hidden)' : 'NOT SET');
    console.log('[GoogleMapsProvider] isLoaded:', isLoaded);
    console.log('[GoogleMapsProvider] loadError:', loadError);
  }, [isLoaded, loadError]);

  if (!GOOGLE_MAPS_API_KEY) {
    console.error('Google Maps API key is not set. Address autocomplete will not work.');
    return <>{children}</>;
  }

  if (loadError) {
    console.error('Error loading Google Maps:', loadError);
    return (
      <>
        {children}
        <Box sx={{ display: 'none' }}>
          <Typography color="error">
            Google Maps failed to load. Address autocomplete unavailable.
          </Typography>
        </Box>
      </>
    );
  }

  if (!isLoaded) {
    // Return children immediately, autocomplete will work once loaded
    return <>{children}</>;
  }

  return <>{children}</>;
};

export default GoogleMapsProvider;
